<header class="header1" >
  <div class="container-menu-header" *ngIf="!isInMobile()">
    <div class="wrap_header">
      <a id="logo-home-button" href="index.html" class="logo">
        <img src="assets/img/larifamos-logo.png" class="img-fluid" alt="La Rifamos logo">
        <img src="assets/img/larifamos-logo-text.png" class="logotext" style="height: 20px;" alt="Responsive image">
      </a>
      <div class="wrap_menu">
        <nav class="menu">
          <ul class="main_menu">
            <li>
              <a id="home-button" routerLink="/">Inicio</a>
            </li>
            <li *ngIf="laRifamosContext.showCampaignsOption">
              <a id="campaigns-button" routerLink="/campaigns">Promociones! <span
                  class="badge badge-danger">Nuevo</span></a>
            </li>
            <li>
              <a id="how-it-work-button" routerLink="/howitwork">¿Cómo funciona?</a>
            </li>
            <li *ngIf="isRaffleSimulatorEnable()">
              <a id="raffle-simulator-button" routerLink="/raffle-proposal">Quiero rifar</a>
            </li>
            <li>
              <a id="faqs-button" routerLink="/faqs">Preguntas frecuentes</a>
            </li>
            <li>
              <a id="about-us-button" routerLink="/aboutus">Sobre nosotros</a>
            </li>
            <li>
              <a id="contact-button" routerLink="/contact">Contacto</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="header-icons">
        <div class="wrap_menu">
          <nav class="menu">
            <ul *ngIf="!isSigninPage() && !isSignupPage() && !getIsLogged()" class="main_menu">
              <li>
                <a id="signup-button" routerLink="/signup">Crear cuenta</a>
              </li>
              <span class="linedivide1-nav"></span>
              <li>
                <a id="signin-button" routerLink="/signin">Ingresar</a>
              </li>
            </ul>

            
            <div *ngIf="getIsLogged()" class="main_menu" style="width: 100%;">
              <div class="d-flex align-items-center wallet-section" style="gap: 8px;">
                <button id="wallet" (click)="this.router.navigate(['/cash-backs']);" name="cash-backs">
                  <i class="fas fa-wallet color-white"></i>
                </button>
                <span class="color-white" style="margin-right: 1%; margin-left: 1%;">{{countryCurrency}}{{walletAvailable}}</span>
              </div>
                <span id="user-logged-button" class="color-white" style="margin-left: 12px;">Hola {{getCurrentUser().firstName}}</span>
                <button id="accountMenu" mat-button [matMenuTriggerFor]="accountMenu">
                  <mat-icon class="account-icon hand color-white">account_circle</mat-icon>
                </button>
                <mat-menu #accountMenu="matMenu" class="custom-menu">
                  <button id="user-profile-button"  class="mat-mdc-menu-item" (click)="redirectToPage($event)" name="editUserProfile">Mi perfil</button>
                  <button id="change-password-button" class="mat-mdc-menu-item" (click)="redirectToPage($event)" name="changePassword">Cambiar contraseña</button>
                  <button id="user-participation-button"  class="mat-mdc-menu-item" (click)="redirectToPage($event)" name="userParticipation">Mis participaciones</button>
                  <button id="credit-card-button"  class="mat-mdc-menu-item" *ngIf="isUserPaymentModesFeatureEnable()" (click)="redirectToPage($event)" name="paymentModes">
                    Mis Formas de pago
                  </button>
                  <button id="account-manager-button" class="mat-mdc-menu-item" *ngIf="isAnAccountManager()" (click)="redirectAsAccountManager()">Gestor de rifa</button>
                  <button id="seller-button" class="mat-mdc-menu-item" *ngIf="isASeller()" (click)="redirectAsSeller()">Vendedor</button>
                  <button id="logout-button" class="mat-mdc-menu-item"  (click)="signout()">Cerrar sesión</button>
                </mat-menu>
              </div>
          </nav>
        </div>

      </div>
    </div>
  </div>


  <div class="wrap_header_mobile">
    <a id="logo-home-button" href="index.html" class="logo-mobile">
      <img src="assets/img/larifamos-logo.png" class="img-fluid" alt="La Rifamos logo">
      <img src="assets/img/larifamos-logo-text.png" class="logotext" style="height: 20px;" alt="Responsive image">
    </a>
    <div class="btn-show-menu ">
      <div *ngIf="getIsLogged()" style="display: flex; align-items: center; margin-right: 15px; gap: 6px;">
        <button id="wallet" (click)="this.router.navigate(['/cash-backs']);" name="cash-backs" style="background: none; border: none; padding: 0;">
          <i class="fas fa-wallet color-white"></i>
        </button>
        <span class="color-white" style="font-weight: 500;">{{countryCurrency}}{{walletAvailable}}</span>
      </div>
      <div>
        <button id="mobileOptionsMenu" mat-button [matMenuTriggerFor]="mobileMenu">
          <span class="hamburger-box">
            <span id="menu-button" class="hamburger-inner"></span>
          </span>
        </button>
        <mat-menu backdropClass="menu-mobile" #mobileMenu="matMenu" class="custom-menu-mobile">
          <button id="home-button" class="item-menu-mobile mat-mdc-menu-item" name=""
            (click)='redirectToPage($event)'>Inicio</button>
          <button id="campaigns-button" class="item-menu-mobile mat-mdc-menu-item" name="campaigns"
            (click)='redirectToPage($event)' *ngIf="laRifamosContext.showCampaignsOption">Promociones! <span class="badge badge-danger">Nuevo</span></button>
          <button id="how-it-work-button" class="item-menu-mobile mat-mdc-menu-item" name="howitwork"
            (click)='redirectToPage($event)'>¿Cómo funciona?</button>
          <button id="raffle-simulator-button" *ngIf="isRaffleSimulatorEnable()" class="item-menu-mobile mat-mdc-menu-item" name="raffle-proposal"
            (click)='redirectToPage($event)'>Quiero rifar!</button>
          <button id="faqs-button" class="item-menu-mobile mat-mdc-menu-item" name="faqs"
            (click)='redirectToPage($event)'>Preguntas frecuentes</button>
          <button id="about-us-button" class="item-menu-mobile mat-mdc-menu-item" name="aboutus"
            (click)='redirectToPage($event)'>Sobre nosotros</button>
          <button id="contact-button" class="item-menu-mobile mat-mdc-menu-item" name="contact"
            (click)='redirectToPage($event)'>Contacto</button>
          <button id="signup-button" *ngIf="!isSigninPage() && !isSignupPage() && !getIsLogged()"
            class="item-menu-mobile mat-mdc-menu-item" name="signup" (click)='redirectToPage($event)'>Crear cuenta</button>
          <button id="signin-button" *ngIf="!isSigninPage() && !isSignupPage() && !getIsLogged()"
            class="item-menu-mobile mat-mdc-menu-item" name="signin" (click)='redirectToPage($event)'>Ingresar</button>

          <!-- Opciones para usuario logueado en menú hamburguesa -->
          <button id="credit-card-button" *ngIf="getIsLogged() && isUserPaymentModesFeatureEnable()" class="item-menu-mobile mat-mdc-menu-item" (click)="redirectToPage($event)" name="paymentModes">
            Mis Formas de pago
          </button>
          <button id="account-manager-button" *ngIf="getIsLogged() && isAnAccountManager()" class="item-menu-mobile mat-mdc-menu-item" (click)="redirectAsAccountManager()">
            Gestor de rifa
          </button>
          <button id="seller-button" *ngIf="getIsLogged() && isASeller()" class="item-menu-mobile mat-mdc-menu-item" (click)="redirectAsSeller()">
            Vendedor
          </button>
          <button id="logout-button" *ngIf="getIsLogged()" class="item-menu-mobile mat-mdc-menu-item" style="border-top: 1px solid rgba(255,255,255,0.15);" (click)="signout()">
            Cerrar sesión
          </button>
        </mat-menu>
      </div>
    </div>
    
  </div>  
</header>